<div class="permissions-header-container-integration">
    <span *ngIf="fullAccessPermission" class="center-item permission-name">{{strings["fullAccess"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["admin"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["execute"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["processLogs"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["warningAndErrorLogs"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["dataValidation"]}}</span>
    <span *ngIf="!fullAccessPermission" class="center-item permission-name">{{strings["output"]}}</span>
</div>

<div class="permissions-checkbox-container">
    <!-- Full Access Access checkbox -->
    <input *ngIf="fullAccessPermission" 
        class="left-align-item checkbox" type="checkbox" 
        [checked]="integrationsFullAccessEnabled()"
        (click)="toggleIntegrationAdmin()">  

    <!-- Admin checkbox -->
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('Admin')"
        [disabled]="integrationsFullAccessEnabled()">

    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationPermissionEnabled('Process') ||integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('Process')"
        [disabled]="integrationAdminEnabled()">
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationPermissionEnabled('RunLog') || integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('RunLog')"
        [disabled]="integrationAdminEnabled()">
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationPermissionEnabled('ErrorLog') || integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('ErrorLog')"
        [disabled]="integrationAdminEnabled()">
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationPermissionEnabled('DataValidation') || integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('DataValidation')"
        [disabled]="integrationAdminEnabled()">
    <input *ngIf="!fullAccessPermission"
        class="center-item checkbox" type="checkbox"
        [checked]="integrationPermissionEnabled('DataFiles') || integrationAdminEnabled()"
        (click)="toggleIntegrationPermission('DataFiles')"
        [disabled]="integrationAdminEnabled()">
</div>